import './RegisterMap.css'
import { useSettings, useLoaded  } from 'Settings'
import { useState, useEffect } from 'react'
import { regValues, row_content } from 'Export/ExportC'
import { v4 } from 'uuid'
import HexInput from 'HexInput';

const Row = ({ id, masterMode }) => {
	const [settings] = useSettings()
	const g_overwrite = settings['overwrite']
	const value = row_content[id].value
	const [loaded,] = useLoaded()
	
	const overwrite = g_overwrite[row_content[id].related].value
	const setOverwrite = g_overwrite[row_content[id].related].setValue

	const repr_lines = row_content[id].repr(value, settings).split('\n')

	const handleChange = (e) => {
		setOverwrite(e.target.number)
	}
	
	return (
		<tr>
			<td>{`eeprom${id}`}</td>
			<td>{'0x' + (0x40 + parseInt(id)).toString(16)}</td>
			<td>{row_content[id].related}</td>
			<td>{'0x' + (loaded[id]?.value ? loaded[id].value : '0').toString(16)}</td>
			<td className={(value !== loaded[id]?.value ? 'diff' : '')}>{'0x' + value.toString(16)}</td>
			{
				masterMode ?
					<td className={ "d-flex overwrite" + (overwrite ? ' content': '') }>
						<HexInput value={overwrite} onChange={handleChange} />
					</td>
				: <></>
			}
			<td>{repr_lines.map((l) => <div key={v4()}>{l}</div>)}</td>
		</tr>
	)
}

const overwriteSet = (overwrite) => {
	let set = false

	Object.entries(overwrite).forEach(([key, value]) => {
		if (value.value !== "") {
			set = true
		}
	})

	return set
}

export default function RegisterMap() {
	const [settings] = useSettings()
	const overwrite = settings['overwrite']
	const [masterMode, setMasterMode] = useState(false)

	useEffect(() => {
		setMasterMode(overwriteSet(overwrite))
	}, [overwrite])

	regValues(settings, row_content)

	return (
		<div className="register-map">
			<div className="form-check form-switch w-100 mb-3">
				<input
					className="me-1 form-check-input float-end"
					type="checkbox"
					role="switch"
					id="flexSwitchCheckDefault"
					onChange={() => setMasterMode(!masterMode)}
					checked={masterMode}
				/>
				<label className="form-check-label float-end me-5" htmlFor="flexSwitchCheckDefault">Master Mode</label>
			</div>
			<table>
				<thead>
					<tr>
						<th>Regname</th>
						<th>Address</th>
						<th>Related Register</th>
						<th>Loaded</th>
						<th>Value</th>
						{
							masterMode ?
							<th>Overwrite (applied when exported)</th>
							: <></>
						}
						<th>Representation</th>
					</tr>
				</thead>
				<tbody>
					{
					Object.entries(row_content).map(([id,]) => <Row masterMode={masterMode} id={id}  key={id} />)
					}
				</tbody>
			</table>
		</div>
	)
}
